import { Set } from 'immutable';

export default (...keys) => {
    const keySet = (keys.length === 1 && keys[0] instanceof Array) ?
        Set(keys[0]) :
        Set(keys);

    return (v, k) => keySet.has(k);
};
